<a id="csv-donwload"></a>
<p-button
  label="戻る"
  class="nav-button"
  styleClass="p-button-secondary"
  icon="pi pi-arrow-left"
  iconPos="left"
  (click)="goBack()"></p-button>
<p-button
  label="新規取り込み対象の追加"
  styleClass="p-button-success"
  icon="pi pi-plus"
  iconPos="left"
  (click)="toggleRegisterCategoryModal()"></p-button>
<p-button
  label="廃盤商品の登録"
  styleClass="p-button-primary"
  icon="pi pi-plus"
  iconPos="left"
  (click)="toggleRegisterJansModal()"></p-button>

<p-panel
  header="検索"
  [toggleable]="true"
  [collapsed]="false">
  <form [formGroup]="form">
    <div class="grid">
      <div class="col-12 lg:col-12 xl:col-12">
        <div>
          <b>JAN検索</b>
        </div>
        <div class="custom-iconfield">
          <i class="pi pi-search"></i>
          <textarea
            pInputTextarea
            placeholder="JAN or ASIN検索"
            rows="4"
            id="janOrAsin"
            formControlName="keyword"
            class="input-full"></textarea>
        </div>
      </div>
      <div class="col-12 lg:col-4 xl:col-4">
        <div>
          <b>廃盤取り込み対象での絞り込み</b>
        </div>
        <div class="p-field">
          <p-multiselect
            [options]="categories"
            formControlName="category"
            placeholder="絞り込み対象を選択してください"
            display="chip"
            class="w-full">
            <ng-template
              let-group
              #group>
              <div class="flex align-items-center">
                <span>{{ group.label }}</span>
              </div>
            </ng-template>
          </p-multiselect>
        </div>
      </div>
      <div class="col-12 lg:col-4 xl:col-4">
        <div>
          <b>登録日時の絞り込み</b>
        </div>
        <div class="p-field">
          <p-datepicker
            formControlName="fromDate"
            dateFormat="yy/mm/dd"
            placeholder="登録日from"
            class="w-full"
            [showIcon]="true"></p-datepicker>
        </div>
      </div>
      <div class="col-6 lg:col-2 xl:col-2">
        <div>
          <b>アマゾンカテゴリの絞り込み</b>
        </div>
        <p-select
          [options]="amazonCategories"
          formControlName="amazonCategory"
          optionLabel="name"
          [showClear]="true"
          placeholder="カテゴリ"
          [filter]="true"
          class="w-full">
          <ng-template #selectedItem>
            @if (form.value.amazonCategory) {
              <div>
                <div>{{ form.value.amazonCategory.name }}</div>
              </div>
            }
          </ng-template>
          <ng-template
            let-category
            #item>
            <div>{{ category.name }}</div>
          </ng-template>
        </p-select>
      </div>
      <div class="col-12">
        <p-button
          styleClass="p-button-primary"
          label="検索"
          icon="pi pi-search"
          (onClick)="doSearch()"></p-button>
      </div>
    </div>
  </form>
</p-panel>
<div class="table-header-sticky-outer">
  全{{ products.length.toLocaleString() }}件
  <p-table
    #table
    showGridlines
    [value]="products"
    [scrollable]="true"
    scrollHeight="calc(100vh - 400px)"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [reorderableColumns]="true"
    [tableStyle]="{ 'min-width': '1200px' }"
    class="p-datatable-gridlines table-header-sticky">
    <!-- 廃盤は悪用されないようにcsv出力はコメントアウト
    <ng-template pTemplate="caption">
      <div class="p-d-flex">
        <button
          type="button"
          pButton
          pRipple
          icon="pi pi-download"
          (click)="outputCsv()"
          class="p-mr-2"
          pTooltip="CSV"
        tooltipPosition="bottom"></button>
      </div>
    </ng-template>
    -->
    <ng-template #header>
      <tr>
        <th style="width: 6%">画像</th>
        <th style="width: 10%">Keepaグラフ</th>
        <th
          pSortableColumn="asin"
          style="width: 7%">
          ASIN
          <p-sorticon field="asin"></p-sorticon>
        </th>
        <th style="width: 7%">JAN</th>
        <th style="width: 20%; word-wrap: break-word; white-space: normal">商品名</th>
        <th
          pSortableColumn="amazonCategory"
          style="width: 7%">
          Amazonカテゴリ
          <p-sorticon field="amazonCategory"></p-sorticon>
        </th>
        <th
          pSortableColumn="amazonPrice"
          style="width: 7%">
          Amazon価格
          <p-sorticon field="amazonPrice"></p-sorticon>
        </th>
        <th
          pSortableColumn="salesDate"
          style="width: 7%">
          Amazon発売日
          <p-sorticon field="salesDate"></p-sorticon>
        </th>
        <th
          pSortableColumn="category"
          style="width: 7%">
          廃盤取り込み対象
          <p-sorticon field="category"></p-sorticon>
        </th>
        <th
          pSortableColumn="createdAt"
          style="width: 7%">
          登録日時
          <p-sorticon field="createdAt"></p-sorticon>
        </th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-product>
      <tr>
        <td>
          <a
            href="https://www.amazon.co.jp/dp/{{ product.asin }}"
            target="_blank">
            <img
              [src]="product.imageUrl"
              class="border-round"
              style="width: 60px; height: 60px; object-fit: contain" />
          </a>
        </td>
        <td>
          <app-keepa-graph [asin]="product.asin"></app-keepa-graph>
        </td>
        <td>{{ product.asin }}</td>
        <td>
          {{ product.jan }}
        </td>
        <td>
          <div style="word-wrap: break-word; white-space: normal">{{ product.productName }}</div>
        </td>
        <td>{{ product.amazonCategory }}</td>
        <td>{{ product.amazonPrice.toLocaleString() }}</td>
        <td>{{ product.salesDate | japanDate }}</td>
        <td>
          @for (c of product.categories; track c) {
            <div>
              <p-tag
                severity="{{ getSeverity(c.id, c.name) }}"
                value="{{ c.name }}({{ c.initialRegisteredAt | japanDate }})" />
            </div>
          }
        </td>
        <td>
          {{ product.discontinuedAt | japanDate }}
          <div>
            <i
              class="pi pi-user-edit clickable p-1"
              style="font-size: 1.2rem; color: var(--primary-color)"
              pTooltip="メモを編集"
              tooltipPosition="top"
              (click)="openMemoModal(product)"></i>
            @if (!!product.memo) {
              <i
                class="pi pi-info-circle p-1"
                style="font-size: 1.2rem; color: var(--info-color)"
                tooltipPosition="left"
                pTooltip="{{ product.memo }}"></i>
            }
          </div>
          @if (canDelete()) {
            <div class="mt-2">
              <i
                class="pi pi-trash clickable p-1"
                style="font-size: 1.2rem; color: var(--danger-color)"
                pTooltip="削除"
                tooltipPosition="top"
                (click)="deleteProduct(product.id)"></i>
            </div>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  header="新規取り込み対象の追加"
  [(visible)]="showRegisterCategoryModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false">
  <ng-template #content>
    <div class="grid">
      <div class="col-12 lg:col-12 xl:col-12">
        <label for="registerCategoryName">登録する対象の名前</label>
      </div>
      <div class="col-12 lg:col-12 xl:col-12">
        <input
          style="width: 100%"
          pInputText
          id="registerCategoryName"
          [(ngModel)]="registerCategoryName" />
      </div>
      <div class="col-12 lg:col-12 xl:col-12">
        <button
          pButton
          type="button"
          class="p-button-sm"
          (click)="doRegisterCategory()">
          設定する
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="廃盤JANの追加"
  [(visible)]="showRegisterJansModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false">
  <ng-template #content>
    <div class="grid">
      <div class="col-12 lg:col-4 xl:col-4">
        <label for="ms-groupedStores">廃盤取り込み対象</label>
        <div class="card justify-content-center p-label">
          <p-select
            [options]="categories"
            optionLabel="name"
            [showClear]="true"
            placeholder="カテゴリ"
            [(ngModel)]="registerCategory">
            <ng-template #selectedItem>
              @if (registerCategory) {
                <div>
                  <div>{{ registerCategory.label }}</div>
                </div>
              }
            </ng-template>
            <ng-template
              let-category
              #item>
              <div>{{ category.label }}</div>
            </ng-template>
          </p-select>
        </div>
      </div>
      <div class="col-12 lg:col-12 xl:col-12">
        <label for="registerJans">廃盤のJANを入力してください（改行区切り）</label>
      </div>
      <div class="col-12 lg:col-12 xl:col-12">
        <textarea
          pInputTextarea
          rows="10"
          id="registerJans"
          [(ngModel)]="registerJans"
          class="input-full"></textarea>
      </div>
      <div class="col-12 lg:col-12 xl:col-12">
        <button
          pButton
          type="button"
          class="p-button-sm"
          (click)="doRegisterJans()">
          設定する
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="メモを登録"
  [(visible)]="showMemoModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false">
  <div class="grid">
    <div class="col-12 mb-3">
      <textarea
        pInputTextarea
        [(ngModel)]="memo"
        placeholder="メモを入力"
        class="w-full"
        rows="3"></textarea>
    </div>
    <div class="col-12 text-right">
      <p-button
        label="登録"
        [disabled]="!memo"
        (onClick)="doRegisterMemo()"></p-button>
    </div>
  </div>
</p-dialog>
